export const SET_ERRORS = "SET_ERRORS";
export const SET_PROCESSING = "SET_PROCESSING";
export const SET_CLUSTER_STATE = "SET_CLUSTER_STATE";

export const GET_CLUSTER_STATE = "GET_CLUSTER_STATE";
export const GET_CLUSTER_STATE_SUCCESS = "GET_CLUSTER_STATE_SUCCESS";
export const GET_CLUSTER_STATE_FAILURE = "GET_CLUSTER_STATE_FAILURE";

export const CLUSTER_START = "CLUSTER_START";
export const CLUSTER_START_SUCCESS = "CLUSTER_START_SUCCESS";
export const CLUSTER_START_FAILURE = "CLUSTER_START_FAILURE";

export const CLUSTER_STOP = "CLUSTER_STOP";
export const CLUSTER_STOP_SUCCESS = "CLUSTER_STOP_SUCCESS";
export const CLUSTER_STOP_FAILURE = "CLUSTER_STOP_FAILURE";
